// Fills the official EU GARAN label artwork (media/images/garan, Implementing Regulation (EU)
// 2025/1960 Annex II). Only the three fields the regulation allows are touched — the duration
// "XX", "Brand/Trademark" and "Model identifier"; every other node of the official SVG stays as
// published by the Commission.
export const GARAN_YOUR_EUROPE_URL = 'https://europa.eu/youreurope/commercial-guarantee-durability/index.htm';
// the label shows whole years or half years only, the decimal written with a comma (2,5)
export const formatGaranYears = (durationYears) => String(durationYears).replace('.', ',');
const svgCache = {};
export const loadSvgText = (url) => {
    if (!svgCache[url]) {
        svgCache[url] = fetch(url)
            .then((response) => {
            if (!response.ok)
                throw new Error(`GARAN label asset ${response.status}`);
            return response.text();
        })
            // drop the XML prolog: the markup is inserted into an HTML shadow tree
            .then((text) => text.replace(/^\s*<\?xml[^>]*\?>\s*/, ''))
            .catch((error) => {
            delete svgCache[url];
            throw error;
        });
    }
    return svgCache[url];
};
const textOf = (element) => (element.textContent || '').replace(/\s+/g, '');
const findField = (svg, placeholder) => Array.from(svg.querySelectorAll('text')).find((element) => textOf(element) === placeholder);
// replaces the placeholder's tspans with a single one carrying `value`
const setField = (field, value) => {
    const tspan = field.querySelector('tspan');
    Array.from(field.querySelectorAll('tspan')).slice(1).forEach((extra) => extra.remove());
    tspan.removeAttribute('class');
    tspan.textContent = value;
    return tspan;
};
const translateX = (element) => {
    const match = /translate\(\s*([\d.]+)/.exec(element.getAttribute('transform') || '');
    return match ? Number.parseFloat(match[1]) : 0;
};
// nested display: the duration is its only editable element
export const fillNestedGaranLabel = (svg, durationYears) => {
    const years = findField(svg, 'XX');
    if (!years)
        return false;
    setField(years, formatGaranYears(durationYears));
    return true;
};
export const fillFullGaranLabel = (svg, values) => {
    const years = findField(svg, 'XX');
    const brand = findField(svg, 'Brand/Trademark');
    const model = findField(svg, 'Modelidentifier');
    if (!years || !brand || !model)
        return false;
    setField(years, formatGaranYears(values.durationYears));
    setField(brand, values.producerName);
    // "Model identifier" sits flush with the right margin (the mirror of the brand's left margin);
    // keep that edge for values of any length instead of letting them run out of the label.
    const viewBoxWidth = Number.parseFloat((svg.getAttribute('viewBox') || '').split(/\s+/)[2]);
    const modelSpan = setField(model, values.modelIdentifier);
    if (Number.isFinite(viewBoxWidth)) {
        modelSpan.setAttribute('x', String(Math.round((viewBoxWidth - translateX(brand) - translateX(model)) * 100) / 100));
        modelSpan.setAttribute('text-anchor', 'end');
    }
    return true;
};
